import BasePeripheral from '@appblocks/codegeneration/Peripherals/_BasePeripheral';
import {
    SettingType, Setting, BlockType, ValidationMessage, ValidationMessageType,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import Peripherals from '@appblocks/codegeneration/Peripherals';

export default class DHT22 extends BasePeripheral {
    constructor() {
        super();
        this.id = 'dht22';
        this.name = 'DHT22 Temperature and Humidity Sensor';
        this.requirements = ['micropython'];
        this.fileLinks = [

        ];
        this.files = [

        ];

        const settings: Array<Setting> = [
            // {
            //     id: 'VCC',
            //     name: 'VCC',
            //     settingType: SettingType.PIN,
            //     required: true,
            //     meta: '3V3',
            //     default: '',
            // },
            {
                id: 'SDA',
                name: 'SDA',
                settingType: SettingType.PIN,
                meta: 'GPIO',
                required: true,
                default: '',
            },
            // {
            //     id: 'GND',
            //     name: 'GND',
            //     settingType: SettingType.PIN,
            //     meta: 'GND',
            //     required: true,
            //     default: '',
            // },
            {
                id: 'TEMPERATURE',
                name: 'Temperature',
                settingType: SettingType.NAME,
                dataType: TibboDataType.FLOAT,
                required: true,
                default: 'TEMP',
            },
            {
                id: 'HUMIDITY',
                name: 'Humidity',
                settingType: SettingType.NAME,
                dataType: TibboDataType.FLOAT,
                required: true,
                default: 'HUM',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks() {
        const blocks = [];

        const NAME = this.getSettingValue('NAME');
        const SDA = this.getSettingValue('SDA');
        const TEMPERATURE = this.getSettingValue('TEMPERATURE');
        const HUMIDITY = this.getSettingValue('HUMIDITY');
        // const GND = this.getSettingValue('GND');
        // const VCC = this.getSettingValue('VCC');
        // const GNDPIN = Peripherals.getPin(GND, this.project.device.id);
        // const VCCPIN = Peripherals.getPin(VCC, this.project.device.id);

        const boardType = PlatformUtils.getPlaformWokwiId(this.project.device.id);

        const SDAPIN = Peripherals.getPin(SDA, this.project.device.id)?.peripherals
            .filter(p => p.peripheralType === 'gpio')[0];

        const gpioNum = SDAPIN?.peripheralPort;

        blocks.push({
            location: 'IMPORTS',
            blockType: BlockType.CODE,
            id: 'import_dht',
            template: 'import dht',
        });

        blocks.push({
            location: 'VARIABLE_DECLARATIONS',
            blockType: BlockType.CODE,
            template: `${NAME} = dht.DHT22(machine.Pin(${gpioNum}, machine.Pin.IN, machine.Pin.PULL_UP))`,
        });

        blocks.push({
            location: `var_${TEMPERATURE}_update`,
            blockType: BlockType.CODE,
            template: `
${NAME}.measure()
value = ${NAME}.temperature()
var_${TEMPERATURE}_update_completed(value)
    `,
        });

        blocks.push({
            location: `var_${HUMIDITY}_update`,
            blockType: BlockType.CODE,
            template: `
${NAME}.measure()
value = ${NAME}.humidity()
var_${HUMIDITY}_update_completed(value)
    `,
        });

        blocks.push({
            location: 'WOKWI_PARTS',
            blockType: BlockType.CODE,
            template: `
{
    "type": "wokwi-dht22",
    "id": "${NAME}",
    "top": 0,
    "left": -100,
    "attrs": { "temperature": "35", "humidity": "40" }
},`,
        });

        // blocks.push({
        //     location: 'WOKWI_CONNECTIONS',
        //     blockType: BlockType.CODE,
        //   template: `["${NAME}:GND", "${wokwiDeviceId}:${GNDPIN?.constant}", "black", ["v0"]],`,
        // });

        // blocks.push({
        //     location: 'WOKWI_CONNECTIONS',
        //     blockType: BlockType.CODE,
        //     template: `["${NAME}:VCC", "${wokwiDeviceId}:${VCCPIN?.function}", "red", ["v0"]],`,
        // });

        blocks.push({
            location: 'WOKWI_CONNECTIONS',
            blockType: BlockType.CODE,
            template: `["${NAME}:SDA", "${boardType}:GP${gpioNum}", "green", ["v0"]],`,
        });

        return blocks;
    }

    getDetails(): string {
        return 'https://docs.tibbo.com/taiko/ssi_i2c';
    }
}
